<div class="rounded-lg border bg-card text-card-foreground shadow-xs h-full overflow-hidden flex flex-col">
  <div class="h-fit flex flex-row items-center justify-between space-y-1.5 p-6">
    <div class="flex flex-row items-center gap-x-4">
      <a href="/inventario" target="_self"
        class="w-8 h-8 flex items-center justify-center text-slate-400 text-4xl transition-all hover:text-5xl">
        <ng-icon name="lucideChevronLeft"></ng-icon>
      </a>
      <div class="flex flex-col content-around justify-between">
        <h3 class="text-2xl font-semibold leading-none tracking-tight">
          {{ productName }}
        </h3>
        <span class="text-muted-foreground">
          {{ productDescription }}
        </span>
      </div>
    </div>

    <button type="button" class="primary normal" (click)="openModal()">
      + Nuevo Rollo
    </button>
  </div>

  <div class="grow h-full p-6 pt-0 min-h-0">
    <app-data-table [data]="productRolls" [columns]="columns" [searchable]="true" [selectable]="false">
      <ng-template #cellTemplate let-row="row" let-col="col">
        @if (col.key === 'color') {
        <div class="flex justify-center items-center">
          <app-color-total [color]="row.color"></app-color-total>
        </div>
        } @else if (col.key === 'actions') {
        <div class="flex items-center justify-center space-x-1">
          <button class="ghost sm text-muted-foreground hover:text-foreground" type="button" (click)="updateRoll(row)">
            <ng-icon name="lucidePenLine" class="w-5 h-5 text-secondary-foreground"></ng-icon>
          </button>

          <button class="ghost sm text-destructive" type="button" (click)="deleteRoll(row.id)">
            <ng-icon name="lucideTrash2" class="w-5 h-5 text-secondary-foreground"></ng-icon>
          </button>
        </div>
        }
      </ng-template>
    </app-data-table>
  </div>
</div>

<app-roll-form [(showModal)]="showModal" [productId]="productId" [(existingRoll)]="existingRoll"></app-roll-form>